module.exports = __webpack_public_path__ + "img/fist.4dce810e.png";